export default __webpack_public_path__ + "static/media/ping-pong-loader.6b3b35bb.svg";